// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { DefaultApi } from '@digitalasset/json-api-ts-client/index';
import React, { useContext } from 'react';
import { WSSupport } from '../utils/WSSupport';

export interface WebAPIs {
  jsonApi: DefaultApi;
  wsSupport: WSSupport;
  setWsEnabled: (enabled: boolean) => void;
}

export const JsonApiContext = React.createContext<WebAPIs | undefined>(undefined);

export const useJsonApiClient: () => DefaultApi = () => {
  const webAPIs = useContext(JsonApiContext);
  if (!webAPIs) {
    throw new Error('Json API v2 client is not initialized');
  }

  return webAPIs.jsonApi;
};

export const useWsSupport: () => WSSupport = () => {
  const webAPIs = useContext(JsonApiContext);
  if (!webAPIs) {
    throw new Error('Json API v2 client is not initialized');
  }
  return webAPIs.wsSupport;
};
